import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useState } from "react";
import { toast } from "react-toastify";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import TextArea from "../components/event-selection/textArea";
import { postFoodsafety } from "../services/foodsafetyService";
import Loaing from "../icons/loaing";
import postEvent from "../services/eventService";
import ConfirmModal from "../components/ConfirmModal";
import FormBorder from "../components/formBorder";
import SelectAndQmark from "../components/event-selection/select&Qmark";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { FoodSafetyPDF } from "../components/dashboard/foodsafety-pdf";
import moment from "moment";
import CalendarIcon from "../icons/calendar";

export type FoodsafetyTypes = {
  eventDate: string;
  reporting: string;
  type: string;
  cause: string;
  actionTaken: string;
  recurrence: string;
  printeventDate?: boolean;
  printtype?: boolean;
  printcause?: boolean;
  printactionTaken?: boolean;
};

const schema = yup.object({
  eventDate: yup.date().required(),
  type: yup.string().required(),
  cause: yup.string().required(),
  actionTaken: yup.string().required(),
});

const FoodSafety = () => {
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState<null | Date>(null);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [pdfData, setPdfData] = useState<any>(undefined);

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm<FoodsafetyTypes>({ resolver: yupResolver(schema) });

  const resetForm = () => {
    setConfirmModalVisible(false);
    reset();
    setPdfData(null);
  };

  const handleDownload: SubmitHandler<FoodsafetyTypes> = async (data) => {
    data.eventDate = moment(startDate).format("YYYY-MM-DD");
    setPdfData(data);
  };
  const onSubmit: SubmitHandler<FoodsafetyTypes> = async (data) => {
    setLoading(true);
    try {
      const {
        printactionTaken,
        printcause,
        printtype,
        printeventDate,
        ...rest
      } = data;
      rest.eventDate = moment(startDate).format("YYYY-MM-DD");
      const response = await postFoodsafety({ ...rest });
      if (response.message === "created") {
        // TODO: needs test
        const eventpost = await postEvent({
          eventId: response.data._id,
          severity: response.data?.securityLevel,
          eventDetailsDate: response.data?.eventDate,
        });
        if ((eventpost.message = "created")) {
          toast.success("food safety event created succesfully!");
          setLoading(false);
          navigate("/confirm");
        }
      }
      if (response.message === "created") {
        navigate("/confirm");
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };
  const { t } = useTranslation();
  return (
    <section className="relative font-Poppins px-[20px] lg:px-0">
      <div>
        <div className="grid gap-3 lg:mx-10">
          <div className="w-16 h-16">
            <img
              src="/images/report.png"
              alt="!"
              className="max-w-full h-auto"
            />
          </div>
          <h1 className="text-4xl font-bold">
            <Trans i18nKey="Food Safety Issues">Food Safety Issues</Trans>
          </h1>
          <p className="text-xl text-[#6B6B6B]">
            <Trans i18nKey="food_safety_description">
              Please note here the details of safety issues, congrats! No need
              to report it. However, for “presence of extraneous material in the
              food”, report the incident only if the material has been in the
              child’s mouth or ingested by the child (if it was found and
              removed before the child has eaten it, congrats! no need to report
              it)
            </Trans>
          </p>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-end gap-[15px] lg:px-[20px] my-5 lg:mb-10">
          <button
            type="button"
            className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
            onClick={() => setConfirmModalVisible(true)}
          >
            <Trans t={t}>Reset</Trans>
          </button>
          {pdfData ? (
            <PDFDownloadLink
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              document={<FoodSafetyPDF formData={pdfData} />}
              fileName={"food-safety-issue.pdf"}
            >
              {({ blob, url, loading, error }) =>
                loading ? "Loading..." : "Download PDF"
              }
            </PDFDownloadLink>
          ) : (
            <button
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={handleSubmit(handleDownload)}
            >
              <Trans>Generate PDF</Trans>
            </button>
          )}
        </div>

        <FormBorder>
          <div className="grid gap-5">
            <div className="grid md:grid-cols-2 grid-cols-1 w-full gap-[5px] md:gap-0 ">
              <label
                htmlFor="eventDate"
                className="font-normal text-xl text-[#1E408E]"
              >
                <Trans t={t}>Event Date</Trans>
              </label>
              <div className=" pr-10">
                <div className="flex flex-row">
                  <div className="mr-4 bg-white w-full flex items-center border border-[#8692A6] h-12 p-2 rounded">
                    <Controller
                      control={control}
                      {...register(`eventDate`)}
                      name="eventDate"
                      render={({ field }) => (
                        <DatePicker
                          filterDate={(d) => {
                            return new Date() > d;
                          }}
                          selectsRange={false}
                          onChange={(date: Date) => {
                            field.onChange(date?.toDateString());
                            setStartDate(date);
                          }}
                          placeholderText="mm/dd/yyyy"
                          selected={startDate}
                          dateFormat={"dd MMM yyyy"}
                          isClearable={false}
                          className="w-full border-none p-0 bg-white focus:outline-none"
                        />
                      )}
                    />
                    <CalendarIcon />
                  </div>
                  <input
                    type="checkbox"
                    {...register("printeventDate")}
                    defaultChecked
                    id={"printeventDate"}
                  />
                </div>
                {errors["eventDate"] && (
                  <p className="text-red-500 mt-2 text-sm">
                    {errors["eventDate"]?.message}
                  </p>
                )}
              </div>
            </div>
            <SelectAndQmark
              printEnabled
              register={register}
              errors={errors}
              name="type"
              label="Type"
              options={[
                "Select",
                "Choking food parts not removed, Eg. Fishbone",
                "Foreign objects found in food",
                "Hot food burn",
                "Food Contamination due to mishandling",
                "Bacteria from food source",
                "Other serious case",
              ]}
              translateId="Type"
              i18nKey="Help Box - Food Safety Issue - Food safety issues"
            />

            <TextArea
              printEnabled
              register={register}
              errors={errors}
              name="cause"
              label="Cause"
              translateId="Cause"
            />
            <TextArea
              printEnabled
              register={register}
              errors={errors}
              name="actionTaken"
              label="Actions Taken"
              translateId="actionTaken"
            />
          </div>
        </FormBorder>
        <div className="flex justify-end lg:px-[20px] mt-10">
          <button
            type={"submit"}
            className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
          >
            <Trans i18nKey="Submit">Submit</Trans>
          </button>
          {loading && <Loaing />}
        </div>
      </form>
      <ConfirmModal
        isOpen={confirmModalVisible}
        setIsOpen={setConfirmModalVisible}
        onConfirm={resetForm}
      />
    </section>
  );
};

export default FoodSafety;
